module.exports = __webpack_public_path__ + "static/media/julia_wi.ab9a7aae.jpg";